import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from 'react-bootstrap';
import config from './config.json';

const Step6 = ({ nextStep, setStep }) => {

  const currentStep = 6;
  const [checked, setChecked] = useState([]);
  const storedValue = localStorage.getItem('heating_energy');
  const storedValue2 = localStorage.getItem('type_bien');

  const handleChange = (e) => {
    const updatedList = [...checked];
    if (e.target.checked) {
      updatedList.push(e.target.value);
    } else {
      const index = checked.indexOf(e.target.value);
      if (index !== -1) {
        updatedList.splice(index, 1);
      }
    }
    setChecked(updatedList);
    localStorage.setItem('work_types', JSON.stringify(updatedList));
  };

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('work_types'));
    if (storedData && storedData.length > 0) {
      setChecked(storedData);
    }
  }, []); 

  const prevSteps = () => {

    if (storedValue === 'pompe_chaleur' || storedValue === 'charbon' || storedValue === 'bois') {
      setStep(4);
    } else {
      setStep(5);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
     
     if(checked.includes('isolation des combles')) {
      nextStep();
    }
    else if(checked.includes('isolation des murs')) {
      setStep(10);
    }
    else if(checked.includes('isolation du sol')) {
     setStep(12);
    }
    else if(checked.includes('fenêtres')) {
     setStep(14);
    }
    else if(checked.includes("isolation d'une toiture-terrasse")) {
     setStep(15);
    } 
    else if(checked.includes('pompe à chaleur air/eau')) {
     setStep(16);
    } 
    else if(checked.includes('pompe à chaleur géothermique') || checked.includes('Climatisation réversible')) {
     setStep(19);
    } 
    else if(checked.includes('pompe à chaleur hybride')) {
     setStep(21);
    } 
    else if(checked.includes('Chaudière gaz à condensation')) {
      setStep(23);
    }
    else if(checked.includes('radiateur électrique')) {
      setStep(25);
    }
    else if(checked.includes('chaudière bois')) {
     setStep(26);
    }
    else if(checked.includes('poêle à bois')) {
     setStep(28); 
    }
    else if(checked.includes('combo isolation + chauffage') || 
        checked.includes('vmc double flux') || 
        checked.includes('chaudière fioul à condensation') || 
        checked.includes('insert cheminée') || 
        checked.includes('Chauffe-eau Solaire Individuel') ||
        checked.includes('Chauffe-eau Thermodynamique') ||
        checked.includes('système solaire') ||
        checked.includes('panneaux solaires')) {

        setStep(29);
     }
  };

  return (
    <Container>
      <ProgressBar
        now={(currentStep / 36) * 100}
        style={{ backgroundColor: "#bad7f1" }}
      >
      <ProgressBar
        now={(currentStep / 36) * 100}
        style={{ backgroundColor: "#0be288" }}
      />
      </ProgressBar>
      <Form onSubmit={handleSubmit}>
         <Row className="mb-3">
            <Col>
                <h2>{config.step6.step}</h2>
                <h3>{config.step6.title}</h3>
              <p>{config.step6.text}</p>
            </Col>
          </Row>
        {checked.length > 5 &&<div className="alert alert-danger">Vous pouvez sélectionner au maximum 5 travaux</div>}
         <h3>{config.step6.prestation1.title}</h3>
        <Row className="mb-3 container-bloc">
            <Col
              className={`m-2 icon-container ${checked.includes("isolation des combles") ? 'selected' : ''}`}
            >
            <label>
              <Form.Check
                type="checkbox"
                value="isolation des combles"
                checked={checked.includes('isolation des combles')}
                onChange={handleChange}
                className="d-none"
              />
              <div>
                <img src={`${config.linkImage}${config.step6.prestation1.image1}`} className="size-img" />
                  <p>
                    {config.step6.prestation1.label1}
                  </p>
              </div>
            </label>
          </Col>
          <Col
            className={`m-2 icon-container ${checked.includes("isolation des murs") ? 'selected' : ''}`}
          >
          <label>
            <Form.Check
              type="checkbox"
              value="isolation des murs"
              checked={checked.includes('isolation des murs')}
              onChange={handleChange}
              className="d-none"
            />
              <div>
                  <img src={`${config.linkImage}${config.step6.prestation1.image2}`} className="size-img" />
                  <p>
                    {config.step6.prestation1.label2}
                  </p>
              </div>
            </label>
          </Col>
          <Col
            className={`m-2 icon-container ${checked.includes("isolation du sol") ? 'selected' : ''}`}
          >
          <label>
            <Form.Check
              type="checkbox"
              value="isolation du sol"
              checked={checked.includes('isolation du sol')}
              onChange={handleChange}
              className="d-none"
            />
            <div>
                <img src={`${config.linkImage}${config.step6.prestation1.image3}`} className="size-img" />
                <p>
                  {config.step6.prestation1.label3}
                </p>
            </div>
          </label>
        </Col>
          <Col
            className={`m-2 icon-container ${checked.includes("fenêtres") ? 'selected' : ''}`}
          >
            <label>
              <Form.Check
                type="checkbox"
                value="fenêtres"
                checked={checked.includes('fenêtres')}
                onChange={handleChange}
                className="d-none"
              />
              <div>
                <img src={`${config.linkImage}${config.step6.prestation1.image4}`} className="size-img" />
                <p>
                  {config.step6.prestation1.label4}
                </p>
              </div>
            </label>
          </Col>
          <Col
            className={`m-2 icon-container ${checked.includes("isolation d'une toiture-terrasse") ? 'selected' : ''}`}
          >
              <label>
                <Form.Check
                  type="checkbox"
                  value="isolation d'une toiture-terrasse"
                  checked={checked.includes("isolation d'une toiture-terrasse")}
                  onChange={handleChange}
                  className="d-none"
                />
              <div>
                  <img src={`${config.linkImage}${config.step6.prestation1.image5}`} className="size-img" />
                  <p>
                    {config.step6.prestation1.label5}
                  </p>
                </div>
              </label>
          </Col>
          <Col
            className={`m-2 icon-container ${checked.includes('vmc double flux') ? 'selected' : ''}`}
          >
            <label>
              <Form.Check
                type="checkbox"
                value="vmc double flux"
                checked={checked.includes('vmc double flux')}
                onChange={handleChange}
                className="d-none"
              />
              <div>
                  <img src={`${config.linkImage}${config.step6.prestation1.image6}`} className="size-img" />
                  <p>
                    {config.step6.prestation1.label6}
                  </p>
              </div>
            </label>
          </Col>
        </Row>
         <h3>{config.step6.prestation2.title}</h3>
        <Row className="mb-3 container-bloc">
          <Col
            className={`m-2 icon-container ${checked.includes('pompe à chaleur air/eau') ? 'selected' : ''}`}
          >
              <label>
                <Form.Check
                  type="checkbox"
                  value="pompe à chaleur air/eau"
                  checked={checked.includes('pompe à chaleur air/eau')}
                  onChange={handleChange}
                  className="d-none"
                />
                <div>
                  <img src={`${config.linkImage}${config.step6.prestation2.image1}`} className="size-img" />
                  <p>
                    {config.step6.prestation2.label1}
                  </p>
                </div>
              </label>
          </Col>
      
          <Col
            className={`m-2 icon-container ${checked.includes('pompe à chaleur géothermique') ? 'selected' : ''}`}
          >
              <label>
                <Form.Check
                  type="checkbox"
                  value="pompe à chaleur géothermique"
                  checked={checked.includes('pompe à chaleur géothermique')}
                  onChange={handleChange}
                  className="d-none"
                />
                <div>
                  <img src={`${config.linkImage}${config.step6.prestation2.image2}`} className="size-img" />
                    <p>
                      {config.step6.prestation2.label2}
                    </p>
                </div>
              </label>
          </Col>
          
          <Col
            className={`m-2 icon-container ${checked.includes('Climatisation réversible') ? 'selected' : ''}`}
          >
            <label>  
              <Form.Check
                type="checkbox"
                value="Climatisation réversible"
                checked={checked.includes('Climatisation réversible')}
                onChange={handleChange}
                className="d-none"
              />
              <div>
                <img src={`${config.linkImage}${config.step6.prestation2.image3}`} className="size-img" />
                  <p>
                    {config.step6.prestation2.label3}
                  </p>
              </div>
            </label>
          </Col>
          <Col
            className={`m-2 icon-container ${checked.includes('pompe à chaleur hybride') ? 'selected' : ''}`}
          >
              <label>
                <Form.Check
                  type="checkbox"
                  value="pompe à chaleur hybride"
                  checked={checked.includes('pompe à chaleur hybride')}
                  onChange={handleChange}
                  className="d-none"
                />
                <div>
                  <img src={`${config.linkImage}${config.step6.prestation2.image4}`} className="size-img" />
                    <p>
                      {config.step6.prestation2.label4}
                    </p>
                </div>
              </label>
          </Col>
        </Row>
         <h3>{config.step6.prestation3.title}</h3>
        <Row className="mb-3 container-bloc">
          <Col
            className={`m-2 icon-container ${checked.includes('chaudière fioul à condensation') ? 'selected' : ''}`}
          >
          <label>
            <Form.Check
              type="checkbox"
              value="chaudière fioul à condensation"
              checked={checked.includes('chaudière fioul à condensation')}
              onChange={handleChange}
              className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation3.image1}`} className="size-img" />
                <p>
                  {config.step6.prestation3.label1}
                </p>
            </div>
           </label>
         </Col>
          <Col
            className={`m-2 icon-container ${checked.includes('Chaudière gaz à condensation') ? 'selected' : ''}`}
          >
          <label> 
            <Form.Check
              type="checkbox"
              value="Chaudière gaz à condensation"
              checked={checked.includes('Chaudière gaz à condensation')}
              onChange={handleChange}
              className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation3.image2}`} className="size-img" />
                <p>
                  {config.step6.prestation3.label2}
                </p>
            </div>
          </label>
         </Col>
        <Col
          className={`m-2 icon-container ${checked.includes('radiateur électrique') ? 'selected' : ''}`}
        >
          <label> 
            <Form.Check
            type="checkbox"
            value="radiateur électrique"
            checked={checked.includes('radiateur électrique')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation3.image3}`} className="size-img" />
                <p>
                  {config.step6.prestation3.label3}
                </p>
            </div>
          </label>
      </Col>
    </Row>
    {storedValue2 !== 'appartement' && (
     <> 
     <h3>{config.step6.prestation4.title}</h3>
    <Row className="mb-3 container-bloc">
      <Col
        className={`m-2 icon-container ${checked.includes('chaudière bois') ? 'selected' : ''}`}
      >
          <label>
            <Form.Check
            type="checkbox"
            value="chaudière bois"
            checked={checked.includes('chaudière bois')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation4.image1}`} className="size-img" />
                <p>
                  {config.step6.prestation4.label1}
                </p>
            </div>
         </label>
      </Col>
      <Col
        className={`m-2 icon-container ${checked.includes('insert cheminée') ? 'selected' : ''}`}
      >
          <label>
            <Form.Check
            type="checkbox"
            value="insert cheminée"
            checked={checked.includes('insert cheminée')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation4.image2}`} className="size-img" />
                <p>
                  {config.step6.prestation4.label2}
                </p>
            </div>
          </label>
      </Col>
      <Col
        className={`m-2 icon-container ${checked.includes('poêle à bois') ? 'selected' : ''}`}
      >
          <label> 
            <Form.Check
            type="checkbox"
            value="poêle à bois"
            checked={checked.includes('poêle à bois')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation4.image3}`} className="size-img" />
                <p>
                  {config.step6.prestation4.label3}
                </p>
            </div>
          </label>
      </Col>
    </Row>
    <h3>{config.step6.prestation5.title}</h3>
    
    <Row className="mb-3 container-bloc">
      <Col
        className={`m-2 icon-container ${checked.includes('panneaux solaires') ? 'selected' : ''}`}
      >
          <label>
            <Form.Check
            type="checkbox"
            value="panneaux solaires"
            checked={checked.includes('panneaux solaires')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation5.image1}`} className="size-img" />
                <p>
                  {config.step6.prestation5.label1}
                </p>
            </div>
          </label>
      </Col>
      <Col
        className={`m-2 icon-container ${checked.includes('système solaire') ? 'selected' : ''}`}
      >
          <label>
            <Form.Check
            type="checkbox"
            value="système solaire"
            checked={checked.includes('système solaire')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation5.image2}`} className="size-img" />
                <p>
                  {config.step6.prestation5.label2}
                </p>
            </div>
          </label>
      </Col>
    </Row>
    </>
   )} 
    <h3>{config.step6.prestation6.title}</h3>
    <Row className="mb-3 container-bloc">
        <Col
          className={`m-2 icon-container ${checked.includes('Chauffe-eau Thermodynamique') ? 'selected' : ''}`}
        >
          <label>
            <Form.Check
            type="checkbox"
            value="Chauffe-eau Thermodynamique"
            checked={checked.includes('Chauffe-eau Thermodynamique')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation6.image1}`} className="size-img" />
                <p>
                  {config.step6.prestation6.label1}
                </p>
            </div>
            
          </label>
        </Col>
      {storedValue2 !== 'appartement' && (
        <Col
          className={`m-2 icon-container ${checked.includes('Chauffe-eau Solaire Individuel') ? 'selected' : ''}`}
        >
            <label>
              <Form.Check
              type="checkbox"
              value="Chauffe-eau Solaire Individuel"
              checked={checked.includes('Chauffe-eau Solaire Individuel')}
              onChange={handleChange}
              className="d-none"
              />
              <div>
                <img src={`${config.linkImage}${config.step6.prestation6.image2}`} className="size-img" />
                  <p>
                    {config.step6.prestation6.label2}
                  </p>
              </div>
            </label>
        </Col>
      )} 
    </Row>
    <Row className="mb-3 container-bloc">
        <h3>{config.step6.prestation7.label1}</h3>
        <Col
          className={`m-2 icon-container ${checked.includes('combo isolation + chauffage') ? 'selected' : ''}`}
        >
          <label>
            <Form.Check
            type="checkbox"
            value="combo isolation + chauffage"
            checked={checked.includes('combo isolation + chauffage')}
            onChange={handleChange}
            className="d-none"
            />
            <div>
              <img src={`${config.linkImage}${config.step6.prestation7.image1}`} className="size-img" />
              <p>{config.step6.prestation7.label1}</p>
            </div>
           </label>
      </Col>
    </Row>
    <Row className="mt-3">
      <Col className="d-flex justify-content-between">
        <Button type="button" variant="secondary" onClick={prevSteps}>
          Précédent
        </Button>
        <Button type="submit" variant="primary" disabled={checked.length === 0 || checked.length > 5} className="ms-3">
          Suivant
        </Button>
      </Col>
    </Row>
      </Form>
    </Container>
  );
};

export default Step6;
